import { css } from "@emotion/react";

export const dateWithTimeTooltipContainer = () => css`
  .column-date {
    display: flex;
    align-items: center;
    margin-inline-end: 1rem;
  }
`;
